TrelloModel = require 'app/scripts/models/internal/trello-model'
Util = require 'app/scripts/lib/util'

module.exports = new class extends TrelloModel

  constructor: ->
    super()
    @set(
      query: ""
      suggestions: []
      suggestionSearchTerm: ""
      suggestSearchModelTypes: ""
    )

  getQuery: ->
    @get('query')

  setQuery: (query) ->
    if query != @getQuery()
      @set('query', query)

    if query == ""
      @clearSuggestions()
      @clearSuggestionSearchTerm()
      @clearSuggestionSearchModelTypes()

  removeStringFromQuery: (string) ->
    query = @getQuery()
    re = ///#{Util.escapeForRegex(string)}///

    # if the query contains the string, then it doesn't need to be removed
    if re.test(query)
      val = query.replace(string, '')
      val = Util.stripExtraSpaces(val)
      if val != ""
        val += " "

      @setQuery(val)

  addStringToQuery: (string) ->
    query = @getQuery()
    re = ///#{Util.escapeForRegex(string)}///

    # if the query doesn't contains the stirng, then we need to add it.
    # otherwise, don't do anything.
    if !re.test(query)
      val = "#{query} #{string}"
      val = Util.stripExtraSpaces(val) + " "

      @setQuery(val)

  getSuggestions: ->
    @get('suggestions')

  setSuggestions: (matches) ->
    @set('suggestions', matches)

  clearSuggestions: ->
    @set('suggestions', [])

  getSuggestionSearchTerm: ->
    @get('suggestionSearchTerm')

  setSuggestionSearchTerm: (term) ->
    @set('suggestionSearchTerm', term)

  clearSuggestionSearchTerm: ->
    @set('suggestionSearchTerm', "")

  getSuggestionSearchModelTypes: ->
    @get('suggestSearchModelTypes')

  setSuggestionSearchModelTypes: (type) ->
    @set('suggestSearchModelTypes', type)

  clearSuggestionSearchModelTypes: ->
    @set('suggestSearchModelTypes', "")
